import "@google/model-viewer";
import React, { useEffect, useRef } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  addAnnotations,
  setIsAddingAnnotation,
} from "../../store/slices/AnnotationSlice";
import { setIsDownloading } from "../../store/slices/ExportSlice";
import ModelViewerElement from "../model-viewer-element/ModelViewerElement";

const useStyles = makeStyles(() =>
  createStyles({
    modelViewer: {
      height: "95%",
      width: "100%",
    },
  })
);

const ModelViewer = () => {
  const classes = useStyles();
  const modelViewer = useRef(null);

  const model = useSelector((state) => state.model);
  const environment = useSelector((state) => state.environment);
  const customizer = useSelector((state) => state.customizer);
  const annotations = useSelector((state) => state.annotations);
  const exporter = useSelector((state) => state.export);
  const dispatch = useDispatch();

  const addAnnotation = (e) => {
    const viewer = modelViewer.current;
    const rect = viewer.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const positionAndNormal = viewer.positionAndNormalFromPoint(x, y);
    if (positionAndNormal == null) {
      console.log("no hit result: mouse = ", x, ", ", y);
      return;
    }
    const { position, normal } = positionAndNormal;

    const hotspot = {
      id: `annotation-${
        Math.random().toString(36).substring(7) + Date.now().toString()
      }`,
      slot: "",
      classList: "",
      dataset: {
        position: "",
        normal: "",
      },
      text: "Annotation description",
      mediaImage: "",
      mediaVideo: "",
      attachment: "",
    };
    hotspot["slot"] = `hotspot-${Math.random().toString(36).substring(7)}`;
    hotspot["classList"] = "hotspot";
    hotspot.dataset.position = position.toString();
    if (normal != null) {
      hotspot.dataset.normal = normal.toString();
    }
    viewer.removeEventListener("click", addAnnotation);

    dispatch(setIsAddingAnnotation(false));
    dispatch(addAnnotations(hotspot));
  };

  useEffect(() => {
    modelViewer.current.autoRotate = environment.autoRotate;
  }, [environment.autoRotate]);

  useEffect(() => {
    modelViewer.current.exposure = environment.exposure / 50;
  }, [environment.exposure]);

  useEffect(() => {
    modelViewer.current.shadowIntensity = environment.shadowIntensity / 100;
  }, [environment.shadowIntensity]);

  useEffect(() => {
    modelViewer.current.shadowSoftness = environment.shadowSoftness / 100;
  }, [environment.shadowSoftness]);

  useEffect(() => {
    const viewer = modelViewer.current;
    if (annotations.isAddingAnnotation)
      viewer.addEventListener("click", addAnnotation);
  }, [annotations.isAddingAnnotation]);

  useEffect(() => {
    async function downloadPoster() {
      if (exporter.isDownloading) {
        const blob = await modelViewer.current.toBlob({
          mimeType: "image/png",
          idealAspect: true,
        });
        const posterUrl = URL.createObjectURL(blob);
        dispatch(setIsDownloading(false));
        window.open(posterUrl);
      }
    }
    downloadPoster().then(() => console.log("successfully downloaded"));
  }, [exporter.isDownloading]);

  return (
    <ModelViewerElement
      ref={modelViewer}
      style={classes}
      environmentImage={environment.environmentImage.src}
      src={model.model.src}
      background={customizer.hotspotStyle.background}
      useSkybox={environment.useSkybox}
    />
  );
};

export default ModelViewer;
